import script from "./Rule.vue?vue&type=script&setup=true&lang=js"
export * from "./Rule.vue?vue&type=script&setup=true&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=8baf894c&scoped=true&lang=less"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8baf894c"]])

export default __exports__